import { render, staticRenderFns } from "./PartOrderPropertiesView.vue?vue&type=template&id=cb3c3e80&scoped=true&"
import script from "./PartOrderPropertiesView.vue?vue&type=script&lang=js&"
export * from "./PartOrderPropertiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3c3e80",
  null
  
)

export default component.exports